import React from 'react';

import { ReloadOutlined, SettingOutlined, PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface SelectNotFoundContentProps {
  hint: React.ReactNode;
  settingsPath?: string;
  settingsLabel: React.ReactNode;
  onReload?: () => void;
  reloadLoading?: boolean;
  onAction?: () => void;
}

/**
 * 當 Select 下拉選單中沒有可用選項時，顯示引導使用者前往設定頁面的提示內容。
 * 用於 Ant Design Select 的 notFoundContent prop。
 */
const SelectNotFoundContent: React.FC<SelectNotFoundContentProps> = ({
  hint,
  settingsPath,
  settingsLabel,
  onReload,
  reloadLoading = false,
  onAction,
}) => {
  const { t } = useTranslation();

  return (
    <div style={{ textAlign: 'center', padding: '12px' }}>
      <div style={{ marginBottom: 8, color: '#666' }}>
        {hint}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '4px 8px' }}>
        <Button
          type="link"
          icon={onAction ? <PlusOutlined /> : <SettingOutlined />}
          onClick={onAction || (() => window.open(settingsPath, '_blank'))}
          size="small"
        >
          {settingsLabel}
        </Button>
        {onReload && (
          <Button
            type="link"
            icon={<ReloadOutlined />}
            onClick={onReload}
            loading={reloadLoading}
            size="small"
          >
            {t('common.select.reload_options')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default SelectNotFoundContent;
